module.exports = __webpack_public_path__ + "img/10.59ef2d1c.png";